/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FilePages16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M16 13v1H1.5a.5.5 0 010-1H16zM1.967 11.41l.483.49-.773.488c-.086.087-.248-.058-.215-.16l.505-.818zm7.73-8.118l.774.782L3.61 11.02c-.25.252-.53.47-.832.653l-.231.13-.484-.49c.155-.321.353-.619.59-.883l.184-.192 6.86-6.945zm.194-.196l.966-.978a.547.547 0 01.729.045.563.563 0 01.1.65l-.056.087-.966.979-.773-.783.966-.978-.966.978z"
        />
    </AccessibleSVG>
);

export default FilePages16;
